import { ShoppingBoardView } from '../constants'

export interface TheChirpyestProductItem {
  id: number
  type: string
  data: {
    imageUrl?: string
    url?: string
    link?: string
    base64?: string
  }
}

export type TheChirpyestMatchType = 'name' | 'brand' | 'both'

/** True when a search result matched (at least partly) on brand name, not just the user's own name/username. */
export const isBrandMatch = (
  matchType?: TheChirpyestMatchType | null
): boolean => matchType === 'brand' || matchType === 'both'

export interface TheChirpyestUser {
  user_id: number
  username: string
  image?: string
  name?: string
  short_bio?: string
  community_image?: string
  default_shopping_board_view?: ShoppingBoardView
  match_type?: TheChirpyestMatchType | null
  matched_brand_name?: string | null
  items?: TheChirpyestProductItem[]
}

export interface UsersResultsState {
  data: TheChirpyestUser[]
  finishedLoading: boolean
  offset: number
  size: number
}

export const getQueryString = (
  value: string | string[] | null | undefined
): string => {
  if (Array.isArray(value)) {
    return value[0] ?? ''
  }
  return value ?? ''
}
